var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Table', {
    attrs: {
      "class-name": "add-to-catalog-table",
      "value": _vm.selected_items,
      "columns": _vm.columns,
      "rows": _vm.filteredSelectedItems,
      "rows-count": _vm.filteredSelectedItems.length,
      "filters": _vm.filters,
      "filters-conf": _vm.filtersConf,
      "loading": _vm.formats_loading,
      "show-select": true,
      "dense": true,
      "remote": false,
      "placeholder-title": _vm.$translate('no_product_selected'),
      "placeholder-description": _vm.$translate('no_product_selected_description'),
      "hide-default-footer": true,
      "item-key": "id",
      "item-value": "id"
    },
    on: {
      "input": _vm.updateSelectedItems,
      "on-row-click": _vm.toggleItem,
      "on-filters-change": _vm.onFiltersChange
    },
    scopedSlots: _vm._u([{
      key: "product",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "product-cell py-2"
        }, [_c('div', {
          staticClass: "text-caption grey--text text--darken-1"
        }, [_vm._v(" " + _vm._s(props.row.upc || "—") + " ")]), _c('ProductName', {
          attrs: {
            "product": props.row
          }
        })], 1)];
      }
    }, {
      key: "catalog",
      fn: function fn(props) {
        return [_c('AddToCatalogCatalogCell', {
          attrs: {
            "catalog-entries": props.row.catalog_entries || [],
            "product-format-name": _vm.productFormatName(props.row)
          }
        })];
      }
    }, {
      key: "format",
      fn: function fn(props) {
        return [_c('AddToCatalogCatalogCell', {
          attrs: {
            "product": props.row,
            "show-catalog-entries": false,
            "show-format-picker": true,
            "format-id": props.row.add_format,
            "format-options-list": _vm.formatOptions,
            "formats-loading": _vm.formats_loading,
            "format-errors": _vm.formatErrors(props.row),
            "product-format-name": _vm.productFormatName(props.row)
          },
          on: {
            "format-change": function formatChange($event) {
              return _vm.onFormatChange(props.row, $event);
            }
          }
        })];
      }
    }, {
      key: "unit_amount",
      fn: function fn(props) {
        return [_c('v-text-field', {
          staticClass: "unit-amount-input",
          attrs: {
            "value": props.row.add_unit_amount,
            "label": _vm.unitAmountLabel,
            "type": "text",
            "inputmode": "decimal",
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "prefix": "€"
          },
          on: {
            "input": function input($event) {
              return _vm.onUnitAmountChange(props.row, $event);
            }
          }
        })];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }